export default "/images/888c6cf82469b397286bbc0dc7c6d4eb.avif";